import moment from "moment-timezone";

export const SPACE_SETUP = {
    INVITE_BY_EMAILS_LIMIT: 20,
}

export const CHILD_STATUS = {
    CHECKIN: 'check_in',
    CHECKOUT: 'check_out',
    MISSING: 'missing',
    PENDING: 'pending'
}

export const REPORT_TYPE = {
    NAP: 'nap',
    BATHROOM: 'bathroom',
    ACTIVITY: 'activity',
    MOOD: 'mood',
    MEAL: 'meal',
    HEALTH: 'health_conditions',
    OUTSIDE: 'outside',
    HYDRATION: 'hydration',
    DEVELOPMENT: 'development',
}
export const REPORT_DISPLAY_TYPES = {
    NAP: 'nap',
    BATHROOM: 'bathroom',
    ACTIVITY: 'activity',
    MOOD: 'mood',
    MEAL: 'meal',
    OUTSIDE: 'outside',
    HEALTH: 'health_conditions',
    HYDRATION: 'hydration',
    // DEVELOPMENT: 'development',
}

export const BATHROOM_TYPES = {
    DIARRHEA: 'diarrhea',
    CONSTIPATION: 'constipation',
    DYSURIA: 'dysuria',
    BED_WETTING: 'bed_wetting',
    OLIGURIA: 'oliguria',
    OTHER: 'other',
}
export const BATHROOM_TYPES_DESIGNER = {
    DIARRHEA: {
        BG_COLOR: 'bg-gray-400',
        TEXT_COLOR: 'text-black',
    },
    CONSTIPATION: {
        BG_COLOR: 'bg-gray-400',
        TEXT_COLOR: 'text-black',
    },
    DYSURIA: {
        BG_COLOR: 'bg-gray-400',
        TEXT_COLOR: 'text-black',
    },
    BED_WETTING: {
        BG_COLOR: 'bg-gray-400',
        TEXT_COLOR: 'text-black',
    },
    OLIGURIA: {
        BG_COLOR: 'bg-gray-400',
        TEXT_COLOR: 'text-black',
    },
    OTHER: {
        BG_COLOR: 'bg-gray-400',
        TEXT_COLOR: 'text-black',
    },
}

export const MOOD_TYPES = {
    JOYFULLY: 'joyfully',
    HAPPY: 'happy',
    GOOD: 'good',
    VERY_GOOD: 'very_good',
    SHY: 'shy',
    SLEEPY: 'sleepy',
    BITTERLY: 'bitterly',
    DESPERATE: 'desperate',
    ANGRY: 'angry',
    BORED: 'bored',
    NOT_IN_MOOD: 'not_in_mood',
    SCARED: 'scared',
    SICK: 'sick',
    OTHER: 'other',
}
export const MOOD_TYPES_DESIGNER = {
    HAPPY: {
        ICON: 'fi fi-rr-smile',
        BG_COLOR: 'bg-light-green',
        TEXT_COLOR: 'text-green',
    },
    GOOD: {
        ICON: 'fi fi-rr-grin',
        BG_COLOR: 'bg-light-green',
        TEXT_COLOR: 'text-green',
    },
    VERY_GOOD: {
        ICON: 'fi fi-rr-grin-stars',
        BG_COLOR: 'bg-light-green',
        TEXT_COLOR: 'text-green',
    },
    SHY: {
        ICON: 'fi fi-rr-meh-blank',
        BG_COLOR: 'bg-light-blue',
        TEXT_COLOR: 'text-blue',
    },
    SLEEPY: {
        ICON: 'fi fi-rr-face-sleeping',
        BG_COLOR: 'bg-light-purple',
        TEXT_COLOR: 'text-purple',
    },
    BITTERLY: {
        ICON: 'fi fi-rr-face-expressionless',
        BG_COLOR: 'bg-light-red',
        TEXT_COLOR: 'text-red',
    },
    BORED: {
        ICON: 'fi fi-rr-face-pensive',
        BG_COLOR: 'bg-light-red',
        TEXT_COLOR: 'text-red',
    },
    NOT_IN_MOOD: {
        ICON: 'fi fi-rr-face-unamused',
        BG_COLOR: 'bg-light-red',
        TEXT_COLOR: 'text-red',
    },
    OTHER: {
        ICON: 'fi fi-rr-grin',
        BG_COLOR: 'bg-gray-400',
        TEXT_COLOR: 'text-black',
    },
}
export const HEALTH_CONDITIONS_TYPES = {
    SYMPTOMS: {
        NAME: 'symptoms',
        ICON: 'fi fi-rr-head-side-cough',
        COLOR: 'bg-light-orange',
        OPTIONS: {
            FEVER: 'fever',
            TEMPERATURE: 'temperature',
            STOMACH_ACHE: 'stomach_ache',
            VOMITING: 'vomiting',
            BITTEN_BY_AN_INSECT: 'bitten_by_an_insect',
            RUNNY_NOSE: 'runny_nose',
            OTHER: 'other',
        },
        DESIGNER: {
            FEVER: {
                ICON: 'fi fi-rr-thermometer-alt',
                BG_COLOR: 'bg-light-orange',
                TEXT_COLOR: 'text-dark-orange',
            },
            TEMPERATURE: {
                ICON: 'fi fi-rr-temperature-high',
                BG_COLOR: 'bg-light-orange',
                TEXT_COLOR: 'text-dark-orange',
            },
            COUGH: {
                ICON: 'fi fi-rr-head-side-cough',
                BG_COLOR: 'bg-light-orange',
                TEXT_COLOR: 'text-dark-orange',
            },
            STOMACH_ACHE: {
                ICON: 'fi fi-rr-stomach',
                BG_COLOR: 'bg-light-orange',
                TEXT_COLOR: 'text-dark-orange',
            },
            VOMITING: {
                ICON: 'fi fi-rr-face-vomit',
                BG_COLOR: 'bg-light-orange',
                TEXT_COLOR: 'text-dark-orange',
            },
            BITTEN_BY_AN_INSECT: {
                ICON: 'fi fi-rr-bug',
                BG_COLOR: 'bg-light-orange',
                TEXT_COLOR: 'text-dark-orange',
            },
            RUNNY_NOSE: {
                ICON: 'fi fi-rr-face-nose-steam',
                BG_COLOR: 'bg-light-orange',
                TEXT_COLOR: 'text-dark-orange',
            },
            OTHER: {
                ICON: '',
                BG_COLOR: 'bg-light-orange',
                TEXT_COLOR: 'text-dark-orange',
            },
        }
    },
    PEDIATRIC_CONTROL: {
        NAME: 'pediatric_control',
        ICON: 'fi fi-rr-microscope',
        COLOR: 'bg-light-sky',
        OPTIONS: null
    },
}


export const CLASS_COLORS = {
    PURPLE: {
        BG_COLOR: 'bg-purple',
        TEXT_COLOR: 'text-white',
    },
    BLUE: {
        BG_COLOR: 'bg-blue',
        TEXT_COLOR: 'text-white',
    },
    SKY: {
        BG_COLOR: 'bg-sky',
        TEXT_COLOR: 'text-white',
    },
    GREEN: {
        BG_COLOR: 'bg-green',
        TEXT_COLOR: 'text-white',
    },
    YELLOW: {
        BG_COLOR: 'bg-yellow',
        TEXT_COLOR: 'text-black',
    },
    ORANGE: {
        BG_COLOR: 'bg-orange',
        TEXT_COLOR: 'text-black',
    },
    PINK: {
        BG_COLOR: 'bg-pink',
        TEXT_COLOR: 'text-white',
    },
    RED: {
        BG_COLOR: 'bg-red',
        TEXT_COLOR: 'text-white',
    },
};

export const HYDRATION_TYPES = {
    AM: 'am',
    PM: 'pm',
}

export const HYDRATION_TYPES_DESIGNER = {
    AM: {
        ICON: 'fi fi-rr-sunrise-alt',
        BG_COLOR: 'bg-light-sky',
        TEXT_COLOR: 'text-dark-sky',
    },
    PM: {
        ICON: 'fi fi-rr-sunset',
        BG_COLOR: 'bg-light-orange',
        TEXT_COLOR: 'text-dark-orange',
    },
}

export const PLAN_TYPES = {
    MENU: 'menu',
    ACTIVITY: 'activity',
    EVENT: 'event',
    APPOINTMENT: 'appointment',
}

export const CALENDAR_TYPES = {
    EVENT: 'event',
    APPOINTMENT: 'appointment',
    BIRTHDAY: 'birthday',
}

export const NOTIFICATION_TYPES = {
    APPEARANCE: 'appearance',
    REPORT: 'report',
    MESSAGE: 'message',
    PLAN: 'plan',
    INVOICE: 'invoice',
    PAYMENT_CONFIRM: 'payment-confirmation',
    SUBMISSION: 'submission',
}

export const GENDER_OPTIONS = [
    {
        "label": '',
        "value": "undefined"
    },
    {
        "label": trans('general.gender.female'),
        "value": "female"
    },
    {
        "label": trans('general.gender.male'),
        "value": "male"
    }
]

export const vCalendarDefault = {
    dataInput: "DD-MM-YYYY HH:mm",
    dataInputDate: "DD-MM-YYYY",
    dataInputTime: "HH:mm",
    postDateFormat: "YYYY-MM-DD",
    postDateTimeFormat: "YYYY-MM-DD HH:mm",
    masks: {
        L: "DD-MM-YYYY",
        input: "DD-MM-YYYY HH:mm",
        data: "DD-MM-YYYY"
    }
}

export const ASSESSMENT_ICONS_PATHS = [
    '/img/assessment-icons/emoji-1.png',
    '/img/assessment-icons/emoji-2.png',
    '/img/assessment-icons/emoji-3.png',
    '/img/assessment-icons/emoji-4.png',
    '/img/assessment-icons/emoji-5.png',
    '/img/assessment-icons/emoji-6.png',
    '/img/assessment-icons/emoji-7.png',
    '/img/assessment-icons/emoji-8.png',
    '/img/assessment-icons/emoji-9.png',
    '/img/assessment-icons/emoji-10.png',

    '/img/assessment-icons/number-1.png',
    '/img/assessment-icons/number-2.png',
    '/img/assessment-icons/number-3.png',
    '/img/assessment-icons/number-4.png',
    '/img/assessment-icons/number-5.png',
    '/img/assessment-icons/number-6.png',
    '/img/assessment-icons/number-7.png',
    '/img/assessment-icons/number-8.png',
    '/img/assessment-icons/number-9.png',
    '/img/assessment-icons/number-10.png',

    '/img/assessment-icons/yellow-circle.png',
    '/img/assessment-icons/yellow-heart.png',
    '/img/assessment-icons/glowing-star.png',
    '/img/assessment-icons/clapping-hands.png',
    '/img/assessment-icons/flexed-biceps.png',
    '/img/assessment-icons/ok-hand.png',
    '/img/assessment-icons/pinched-fingers.png',
    '/img/assessment-icons/red-heart.png',
    '/img/assessment-icons/sports-medal.png',
    '/img/assessment-icons/sun-with-face.png',
    '/img/assessment-icons/thumbs-up.png',
    '/img/assessment-icons/victory-hand.png',
    '/img/assessment-icons/white-medium-star.png',
];
export const VUE_PAGINATION_OPTIONS = {
    chunk: 5,
    texts: {
        count: trans('pagination.vue_pagination')
    }
}

export const slugify = str =>
    str
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');


export const objectToUrlParams = (obj) => {
    let params = [];

    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            let value = obj[key];

            if (Array.isArray(value)) {
                value.forEach(item => {
                    params.push(`${encodeURIComponent(key)}[]=${encodeURIComponent(item)}`);
                });
            } else {
                params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
            }
        }
    }

    return params.join('&');
}

export const isBase64 = (str) => {
    const base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

    return base64regex.test(str);
}

export const unFlattenObjectKeys = (data) => {
    const nestedObject = {};

    for (const key in data) {
        const parts = key.split('[');
        let currentLevel = nestedObject;

        for (let i = 0; i < parts.length; i++) {
            const part = parts[i].replace(']', '');

            if (!currentLevel[part]) {
                if (i === parts.length - 1) {
                    currentLevel[part] = data[key];
                } else {
                    currentLevel[part] = {};
                }
            }

            currentLevel = currentLevel[part];
        }
    }

    return nestedObject;
}

export const flattenObjectKeys = (data, prefix = '') => {
    let result = {};

    Object.keys(data).forEach((key) => {
        const value = data[key];
        const finalKey = prefix ? `${prefix}[${key}]` : key;

        if (typeof value === 'object' && value !== null) {
            Object.assign(result, flattenObjectKeys(value, finalKey));
        } else {
            result[finalKey] = value;
        }
    });

    return result;
}

export const randomString = (length = 5) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;

    for (let i = 0; i < length; ++i) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
}

export const getLanguageFromKey = (key) => {
    const map = {
        sq: 'Albanian',
        en: 'English',
        el: 'Greek',
        mk: 'Macedonian',
        sr: 'Serbian',
        tr: 'Turkish',
        bg: 'Bulgarian',
    }

    return map[key] ?? 'English';
}

export const mondayToSundayNumeric  = [1, 2, 3, 4, 5, 6, 0]; // 0 is Sunday

export const locationTimezones = Object.fromEntries(
    moment.tz.names().map(tz => [tz, tz])
);

export const roomIcons = {
    KIDS: 'kids',
    RABBIT: 'rabbit',
    STAR: 'star',
    BUTTER: 'butter',
    BUTTERFLY: 'butterfly',
    KID: 'kid',
    FLOWER: 'flower',
    HEART: 'heart',
}
